import React, { useState } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Input,
    VStack,
  } from '@chakra-ui/react'
import { FaEdit } from 'react-icons/fa';
import axios from 'axios';
import { backendurl } from '../../path';

const InsertTeacher = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [name,setname] = useState();
    const [contact,setcontact] = useState();
    const [email,setemail] = useState();
    const [doj,setdoj] = useState();
    const [salary,setsalary] = useState();

    const handlesave = async()=>{
const response = await axios.post(`${backendurl}/insert-teacher`,{name,contact,email,doj,salary});
if(response.data.isInserted)
{
    window.location.reload();
}
    }
  return (
    
    <VStack>

    <Button onClick={onOpen}><FaEdit color='black'/>&nbsp; Insert Entry</Button>

    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent p={8}>
        <ModalHeader>New Teacher Entry</ModalHeader>
        <ModalCloseButton />
        <ModalBody >
            <VStack>
          <Input placeholder='Teacher name' type='text' value={name} onChange={(e)=>setname(e.target.value)}/>
          <Input placeholder='Teacher contact' type='number' value={contact} onChange={(e)=>setcontact(Number(e.target.value))}/>
          <Input placeholder='Teacher email' type='email' value={email} onChange={(e)=>setemail(e.target.value)}/>
          <Input placeholder='Teacher salary' type='number' value={salary} onChange={(e)=>setsalary(Number(e.target.value))}/>
          <Input placeholder='Date of join' type='date' value={doj} onChange={(e)=>setdoj(e.target.value)}/>
          <Button variant='solid' colorScheme='orange' onClick={handlesave} px={8}>Save</Button>
            </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
    </VStack>
  

  )
}

export default InsertTeacher
